import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import styles from "./styles.pcss";
var cx = classNames.bind(styles);

/**
 * Smooth size transaction between sizes that changes along with contentKey
 */
var SizeSwitcher = /*#__PURE__*/function (_React$Component) {
  _inherits(SizeSwitcher, _React$Component);
  var _super = _createSuper(SizeSwitcher);
  function SizeSwitcher(props) {
    var _this;
    _classCallCheck(this, SizeSwitcher);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "getContentSize", function () {
      var _this$contentRef$curr = _this.contentRef.current,
        clientWidth = _this$contentRef$curr.clientWidth,
        clientHeight = _this$contentRef$curr.clientHeight;
      return {
        width: clientWidth,
        height: clientHeight
      };
    });
    _this.contentRef = /*#__PURE__*/React.createRef();
    _this.state = {};
    return _this;
  }
  _createClass(SizeSwitcher, [{
    key: "getSnapshotBeforeUpdate",
    value: function getSnapshotBeforeUpdate(prevProps) {
      if (prevProps.contentKey !== this.props.contentKey) {
        return this.getContentSize();
      }
      return null;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(_, __, prevSize) {
      var _this2 = this;
      if (prevSize) {
        var _this$getContentSize = this.getContentSize(),
          nextWidth = _this$getContentSize.width,
          nextHeight = _this$getContentSize.height;
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
          width: "".concat(prevSize.width, "px"),
          height: "".concat(prevSize.height, "px")
        }, function () {
          requestAnimationFrame(function () {
            _this2.setState({
              width: "".concat(nextWidth, "px"),
              height: "".concat(nextHeight, "px")
            });
          });
        });
        setTimeout(function () {
          _this2.setState({
            width: null,
            height: null
          });
        }, 350);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      var _this$state = this.state,
        width = _this$state.width,
        height = _this$state.height;
      return /*#__PURE__*/React.createElement("div", {
        className: cx('container'),
        style: {
          width: width,
          height: height
        },
        "data-t-id": "components-SizeSwitcher"
      }, /*#__PURE__*/React.createElement("div", {
        className: cx('component'),
        ref: this.contentRef
      }, children));
    }
  }]);
  return SizeSwitcher;
}(React.Component);
export { SizeSwitcher as default };
SizeSwitcher.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node,
  contentKey: PropTypes.string
} : {};